import { render } from "./overscroll-behavior.md?vue&type=template&id=4cef76a9"
const script = {}
script.render = render

export default script